import {
    GET_TRANSACTION_BALANCE,
    GET_TRANSACTION_BALANCE_FAIL,
    GET_TRANSACTION_BALANCE_OK
} from "../sagas/constants";

const initialState = {
    data: null,

    loading: false,
    loaded: false,

    error: false,
    errorMessage: null,
};

export default function reducer(state=initialState, action) {
    switch(action.type) {

        case GET_TRANSACTION_BALANCE: {
            return {...state, loading: true, error: false}
        }
        case GET_TRANSACTION_BALANCE_FAIL: {
            return {
                ...state,
                loading: false,
                error: true,
                errorMessage: action.payload
            }
        }
        case GET_TRANSACTION_BALANCE_OK: {
            return {
                ...state,
                loading: false,
                loaded: true,
                error: false,
                data: action.payload
            }
        }
        default: {
            return state;
        }
    }
}
